<template>

  <el-dialog title="添加分类" :visible.sync="dialogVisible" @close="dialogFormVisible" :close-on-click-modal="false"
    :close-on-press-escape="false">
    <el-form size="small"  ref="form">
      <el-form-item size="small" label="选择商品">
      <el-button icon="el-icon-plus" @click="changeProduct(product)">选择商品</el-button>
      <div class="pb50" style="margin-top: 10px;">
        <el-table size="small" :data="product" border>
          <el-table-column label="图片" width="60">
            <template slot-scope="scope">
              <div class="product-info">
                <div class="pic">
                  <img width="30px" height="30px" v-img-url="scope.row.product_image" alt="product_image"/></div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="product_name" label="商品"></el-table-column>
          <el-table-column prop="spec_value" label="规格"></el-table-column>
          <el-table-column prop="product_price" label="价格"></el-table-column>
          <el-table-column prop="num" label="设置数量">
            <template slot-scope="scope">
                <el-input type='number' min='1' v-model="scope.row.set_num"></el-input>
            </template>
          </el-table-column>
          <el-table-column fixed="right" label="操作" width="90">
            <template slot-scope="scope">
              <el-button @click="deleteClick(scope.$index)" type="text" size="small">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-form-item>
    <!--商品选择-->
    <SkuProduct :isproduct="isproduct" :excludeIds="excludeIds" :islist="true" @closeDialog="closeDialogFunc"></SkuProduct>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible">取 消</el-button>
      <el-button type="primary" @click="addProduct" :loading="loading">确 定</el-button>
    </div>
  </el-dialog>

</template>

<script>
  import OrderApi from '@/api/order.js';
  import SkuProduct from '@/components/product/SkuProduct';
  import {mergeTable} from '@/utils/table.js';
  export default {
    components: {
       SkuProduct,
    },
    data() {
      return {
         isproduct: false,
          /*产品去重*/
          excludeIds: [],
          loading: false,
          product:[]
      };
    },
    props: ['open_product', 'order_id'],
    created() {
      this.dialogVisible = this.open_product;
    },
    methods: {
      addProduct() {
        let self = this;
        let params = {
          product:self.product,
          order_id:self.order_id
        };
        self.loading = true;
        OrderApi.addProduct(params, true).then(data => {
          self.loading = false;
          self.$message({
            message: '修改成功',
            type: 'success'
          });
          self.dialogFormVisible(true);
        }).catch(error => {
          self.loading = false;
        });
      },  
      /*关闭弹窗*/
      dialogFormVisible(e) {
        if (e) {
          this.$emit('closeDialog', {
            type: 'success',
            openDialog: false
          })
        } else {
          this.$emit('closeDialog', {
            type: 'error',
            openDialog: false
          })
        }
      },
      closeDialogFunc(e) {
        console.log(e)
        let self = this;
        self.isproduct = false;
        if (e.type === 'success') {
          let arr = [];
          for (let i = 0; i < e.params.length; i++) {
            let item = e.params[i];
            let obj = {
              product_name: item.product_name,
              product_id: item.product_id,
              product_sku_id: item.product_sku_id,
              spec_sku_id: item.spec_sku_id,
              image_id: item.image_id,
              spec_value: item.spec_value?item.spec_value:'',
              product_no: item.product_no,
              product_price: item.product_price,
              product_image: item.image,
              set_num:1
            };
            arr.push(obj);
          }
          self.product = self.product.concat(arr);
          self.product = mergeTable(this.product);
        }
    },
    /*打开添加*/
    changeProduct(list) {
      let arr = [];
      list.forEach(item => {
        arr.push(item.product_sku_id);
      });
      this.excludeIds = arr;
      this.isproduct = true;
    },
    /*删除商品*/
    deleteClick(e) {
      let curItem = this.product[e];
      for (let i = 0; i < this.product.length; i++) {
        let item = this.product[i];
        if (curItem.product_sku_id == item.product_sku_id) {
          if (this.type == 'edit' && e.tempProduct != true) {
            let product_sku_id = item.product_sku_id;
            // this.form.product_del_ids.push(product_sku_id);
          }
          this.product.splice(i, 1);
          i--;
        }
      }
    },

    }
  };
</script>

<style>
 .img {
    margin-top: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/views/order/order/dialog/Product.vue